import type { Permission } from '../domain/permission.enum'
import type { Role } from '../domain/role.enum'

import { useAuthStatus } from '../components/auth/auth-context'
import { AuthStatus } from '../components/auth/types'
import { useAppSelector } from '../store'

interface Props {
  element: React.ReactNode
  permissions?: Permission | Permission[]
  roles?: Role | Role[]
}

export function Guard({ permissions = [], roles = [], element }: Props): React.ReactNode {
  const user = useAppSelector(state => state.app.user)
  const isReady = useAppSelector(state => state.app.isReady)
  const authStatus = useAuthStatus()

  const permArray = Array.isArray(permissions) ? permissions : [permissions]
  const roleArray = Array.isArray(roles) ? roles : [roles]

  if (!isReady) {
    return null
  }

  if (authStatus !== AuthStatus.Authenticated) {
    return null
  }

  if (permArray.length > 0 && !permArray.every(p => user.permissions.includes(p))) {
    return null
  }

  if (roleArray.length > 0 && !roleArray.some(r => user.roles.includes(r))) {
    return null
  }

  return element
}
